/**
 * Google Tag Manager Service
 * Utility functions for pushing events to GTM dataLayer
 */

import {
  tGTMAddToCartEvent,
  tGTMPurchaseEvent,
  tGTMSignUpEvent,
} from './gtm.types';

/**
 * Pushes an event to Google Tag Manager dataLayer
 * @param eventData - The event data to push to dataLayer
 */
export function pushToDataLayer(eventData: Record<string, unknown>): void {
  if (typeof window === 'undefined') {
    return;
  }

  // Initialize dataLayer if it doesn't exist
  window.dataLayer = window.dataLayer || [];

  // Push the event to dataLayer
  window.dataLayer.push(eventData);
}

/**
 * Tracks an AddToCart event for GTM
 * This should be called when a non-paying user selects a plan
 * @param options - AddToCart event data
 */
export function trackAddToCartEvent(options: tGTMAddToCartEvent): void {
  pushToDataLayer(options);
}

/**
 * Tracks a Purchase event for GTM
 * This should be called when a free user completes their first purchase
 * @param options - Purchase event data
 */
export function trackPurchaseEvent(options: tGTMPurchaseEvent): void {
  pushToDataLayer(options);
}

/**
 * Tracks a GA4 sign_up event for GTM (GRO-1269)
 * Call it only after the backend confirmed the workspace creation
 * @param options - sign_up event data
 */
export function trackSignUpEvent(options: tGTMSignUpEvent): void {
  pushToDataLayer(options);
}

/**
 * Declares the dataLayer type for TypeScript
 */
declare global {
  interface Window {
    dataLayer: unknown[];
  }
}
